import { Injectable, TemplateRef } from '@angular/core';

export let toastPlacement = {
  topRight: 'top-0 end-0',
  topLeft: 'top-0 start-0',
  bottomCenter: 'bottom-0 start-50 translate-middle-x',
  bottomRight: 'bottom-0 end-0',
  bottomLeft: 'bottom-0 start-0',
}

@Injectable({
  providedIn: 'root'
})
export class ToastsService {

  toast: any;

  constructor() { }

  show(textOrTpl: string | TemplateRef<any>, tempOptions: any = {}, placement = toastPlacement.bottomCenter) {
    const options = {
      delay: 2000,
      ...tempOptions
    };
    this.toast = { textOrTpl, ...options, placement };
  }

  clear() {
    this.toast = null;
  }
}
